module.exports = require('@bugsnag/browser')
